
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1345_5165)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.00009 2.62117L2.62141 5.99985L6.00009 9.37853L9.37877 5.99985L6.00009 2.62117ZM6.7072 1.20696C6.31668 0.816431 5.68351 0.816432 5.29299 1.20696L1.2072 5.29274C0.816675 5.68327 0.816676 6.31643 1.2072 6.70696L5.29299 10.7927C5.68351 11.1833 6.31668 11.1833 6.7072 10.7927L10.793 6.70696C11.1835 6.31643 11.1835 5.68327 10.793 5.29274L6.7072 1.20696Z","fill":"url(#paint0_angular_1345_5165)"}})]),_c('defs',[_c('radialGradient',{attrs:{"id":"paint0_angular_1345_5165","cx":"0","cy":"0","r":"1","gradientUnits":"userSpaceOnUse","gradientTransform":"translate(6.00009 5.99985) rotate(83.122) scale(16.2644 14.0125)"}},[_c('stop',{attrs:{"offset":"0.0782833","stop-color":"#D3BD94"}}),_c('stop',{attrs:{"offset":"0.25","stop-color":"#E3BC69"}}),_c('stop',{attrs:{"offset":"0.56809","stop-color":"#F5EBC8"}}),_c('stop',{attrs:{"offset":"0.66916","stop-color":"#DFB969"}}),_c('stop',{attrs:{"offset":"0.75","stop-color":"#E4BB56"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#ECD9B0"}})]),_c('clipPath',{attrs:{"id":"clip0_1345_5165"}},[_c('rect',{attrs:{"width":"12","height":"12","fill":"white"}})])])])
          )
        }
      }
    